import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-edit-lead-source-dialog',
  templateUrl: './edit-lead-source-dialog.component.html',
  styleUrls: ['./lead-sources.component.css']
})
export class EditLeadSourceDialogComponent implements OnInit {

  constructor(
    public dialogRef: MatDialogRef<EditLeadSourceDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { }

  ngOnInit(): void {
  }

  onClose(): void {
    this.dialogRef.close();
  }

  onSave(): void {
    this.dialogRef.close({ action: 'save', model: this.data.model });
  }

}
